export enum ScreenSizeQueries {
    XLARGE = '(min-width: 1442px)',
    LARGE = '(min-width: 1025px) and (min-height: 600px)',
    MEDIUM = '(min-width: 481px) and (max-width: 1024.99px)',
    SMALL = '(max-width: 480.99px)',
    JWSMALL = '(max-width: 539.99px)',  // JWPlayer's small screen size differs from ours
}